<template>
  <v-container fluid class="pa-0">
    <!-- <v-img :src="banner" :height="bannerHeight">
      <v-container class="fill-height">
        <v-row justify="center" align="center">
          <v-col cols="12" class="three-d">
            <h3 class="text-h5 font-weight-black text-uppercase text-center">Hong Kong</h3>
            <br />
            <h1 class="text-h2 font-weight-black text-uppercase text-center">
              The world's longest
              <br />living population
            </h1>
            <h3 class="text-h5 font-weight-black text-uppercase text-center">Visualised</h3>
          </v-col>
          <v-col cols="12" class="text-center">
            <v-btn @click="$vuetify.goTo('#overview')">Find out more!</v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-img>-->
    <v-row id="about">
      <v-col cols="12">
        <v-container>
          <!-- <h2 class="text-h4 font-weight-black">About the project</h2> -->
          <p>
            The Hong Kong Life Expectancy Profile includes four data
            visualisations, each providing a different perspective to examine
            why Hong Kong has to date the highest life expectancy in the world.
          </p>
          <!-- <p>
            The Hong Kong Life Expectancy Profile depicts. It contains the
            following visualisation for Life Expectancy and Mortality
          </p>-->
          <ol>
            <li>
              Contributions to life expectancy gains in Hong Kong by age, sex,
              and underlying cause of death
              <ol>
                <li>
                  Contributions to life expectancy gap between Hong Kong and
                  high-income countries
                </li>
              </ol>
            </li>
            <li>
              Cohort survival comparisons between Hong Kong and high-income
              countries
            </li>
            <li>
              Deaths attributable to smoking in Hong Kong and high-income
              countries
            </li>
            <li>
              Death rate in Hong Kong by migrant status and other populations
            </li>
          </ol>
          <!-- <ul>
            <li>
              Focused on Hong Kong
              <ul>
                <li>
                  <span class="highlight">Contributions</span> of various causes
                  of death to Life Expectancy, over time, by age group)
                </li>
                <li>
                  Native vs.
                  <span class="highlight">Migrant</span> Hong Kong
                  Citizens
                </li>
              </ul>
            </li>
            <li>
              Comparing Hong Kong (to other high-income countries)
              <ol>
                <li>
                  <span class="highlight">TCAL</span> (or Truncated
                  cross-sectional average length of life), by gender
                </li>
                <li>
                  What propotion of all deaths is attributable to
                  <span class="highlight">smoking</span>?
                </li>
              </ol>
            </li>
          </ul>-->
        </v-container>
      </v-col>
      <!-- <v-col cols="6" class="pa-0">
        <v-img :src="community" :height="communityHeight"></v-img>
      </v-col>-->
    </v-row>
    <v-row id="overview">
      <v-col cols="12">
        <v-container>
          <v-row align="center">
            <v-col cols="12">
              <!-- <h2 class="font-weight-black text-h4">
                Overview of life expectancy in HK
              </h2> -->
              <p>
                Life expectancy is one of the most objective and representative
                measures of the health of a population. The longevity of the
                Hong Kong population is remarkable given that socioeconomic
                development from pre- to post-industrial conditions occurred
                within just one lifetime to reach the highest in the world.
              </p>
              <!-- <p>
                This visualisation depicts the life expectancy of the Hong Kong
                population at birth, males and females, and their corresponding
                world ranking, over time (1960-2019).
              </p> -->
              <p>
                Click on the “ANIMATE” button to find out how Hong Kong compares
                to other jurisdictions in the world, in terms of life expectancy
                and rankings.
              </p>
            </v-col>
            <v-col cols="12">
              <v-btn @click="openModal" color="primary">Animate</v-btn>
            </v-col>
            <v-col cols="12">
              <v-row>
                <!-- <v-col cols="4">explanation of text</v-col> -->
                <v-col cols="12">
                  <h4>Life expectancy at birth in Hong Kong: 1960-2020</h4>
                </v-col>
                <v-col cols="12" sm="8" offset-sm="2">
                  <v-img :src="overview" contain></v-img>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-container>
      </v-col>
      <!-- <v-col cols="12">
        <v-container>
          <v-row>
            <v-col>
              <v-btn @click="openModal" color="primary">Animate</v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-col>-->
    </v-row>
    <v-dialog v-model="showModal" max-width="750">
      <v-card>
        <v-toolbar color="primary" dark>
          <v-toolbar-title>Click play to animate</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="closeModal">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <h2 class="text-center my-3">Life expectancy at birth: 1960-2019</h2>
          <video controls width="100%" :src="video"></video>
          <!-- <div class="circle-container">
            <div class="circle"></div>
            <div class="inline">Hong Kong</div>
          </div> -->
          Source: Gapminder
        </v-card-text>

        <v-card-actions>
          <v-btn color="primary" @click="closeModal">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import video from "../assets/Presentation1.mp4";
import banner from "../assets/banner.webp";
import community from "../assets/community.webp";
import overview from "../assets/Joinpoint 2018 rankings.png";
export default {
  name: "Home",
  props: {
    msg: String,
  },
  data: () => ({
    showModal: false,
    bannerHeight: 400,
    communityHeight: 572,
    banner,
    community,
    overview,
    video,
  }),
  methods: {
    openModal() {
      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
    },
  },
  watch: {
    "$route.path": {
      handler(value) {
        if (value === "/animate") {
          this.openModal();
        } else {
          this.closeModal();
        }
      },
      immediate: true,
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.highlight {
  color: red;
}
.three-d {
  /* color: white; */
  /* --shadow-color: #ffffff; */
  /* --shadow-color-light: rgb(128, 124, 124); */
  text-shadow: 4px 4px 5px #ffffff;
  /* mix-blend-mode: screen; */
  /* animation: neon 3s infinite; */
}
@keyframes neon {
  0% {
    text-shadow: -1px -1px 1px var(--shadow-color-light),
      -1px 1px 1px var(--shadow-color-light),
      1px -1px 1px var(--shadow-color-light),
      1px 1px 1px var(--shadow-color-light), 0 0 3px var(--shadow-color-light),
      0 0 10px var(--shadow-color-light), 0 0 20px var(--shadow-color-light),
      0 0 30px var(--shadow-color), 0 0 40px var(--shadow-color),
      0 0 50px var(--shadow-color), 0 0 70px var(--shadow-color),
      0 0 100px var(--shadow-color), 0 0 200px var(--shadow-color);
  }
  50% {
    text-shadow: -1px -1px 1px var(--shadow-color-light),
      -1px 1px 1px var(--shadow-color-light),
      1px -1px 1px var(--shadow-color-light),
      1px 1px 1px var(--shadow-color-light), 0 0 5px var(--shadow-color-light),
      0 0 15px var(--shadow-color-light), 0 0 25px var(--shadow-color-light),
      0 0 40px var(--shadow-color), 0 0 50px var(--shadow-color),
      0 0 60px var(--shadow-color), 0 0 80px var(--shadow-color),
      0 0 110px var(--shadow-color), 0 0 210px var(--shadow-color);
  }
  100% {
    text-shadow: -1px -1px 1px var(--shadow-color-light),
      -1px 1px 1px var(--shadow-color-light),
      1px -1px 1px var(--shadow-color-light),
      1px 1px 1px var(--shadow-color-light), 0 0 3px var(--shadow-color-light),
      0 0 10px var(--shadow-color-light), 0 0 20px var(--shadow-color-light),
      0 0 30px var(--shadow-color), 0 0 40px var(--shadow-color),
      0 0 50px var(--shadow-color), 0 0 70px var(--shadow-color),
      0 0 100px var(--shadow-color), 0 0 200px var(--shadow-color);
  }
}

/* ol {
  list-style-type: none;
  counter-reset: item;
}
li:before {
  content: "(" counter(section, number) ") ";
}
li {
  counter-increment: section;
} */
ol {
  counter-reset: item;
}
li {
  display: block;
}
li > ol > li:before {
  content: counters(item, ".");
  counter-increment: item;
}
li:before {
  content: "(" counters(item, ".") ")";
  counter-increment: item;
}
/* .circle-container {
  top: -100px;
  left: 100px;
  position: relative;
}
.inline {
  display: inline-block;
}
.circle {
  vertical-align: middle;
  margin-right: 10px;
  display: inline-block;
  background-color: #eb3438;
  border-radius: 50%;
  height: 20px;
  width: 20px;
  border: 1px solid;
} */
</style>
